import {usePage} from '@inertiajs/vue3';
import {computed, ComputedRef} from 'vue';

export type LoggedInUser = {
  id: number;
  lastName: string;
  name: string;
  avatar: string;
  isSuperUser: boolean;
};

export function useLoggedInUser(): ComputedRef<LoggedInUser> {
  const page = usePage();

  return computed(() => page.props.loggedInUser as LoggedInUser);
}
